import HealthyInsideOut from '../../pages/healthyinsideout/HealthyInsideOut'

import PrefixEnum from '../prefixes'

export default Object.freeze([
    { path: PrefixEnum.HEALTHY_INSIDE_OUT, component: HealthyInsideOut },
])
